import { DateTime } from "luxon";

interface UTCWindow {
  utcStartDate: string; // "YYYY-MM-DD"
  utcStartTime: string; // "HH:mm:ss"
  utcEndDate: string;
  utcEndTime: string;
}

export function convertCampaignWindowToUTC(
  campaignStartDate: string,  // format: "DD/MM/YYYY"
  campaignEndDate: string,    // format: "DD/MM/YYYY"
  startTime: string,          // format: "HH:mm"
  endTime: string,            // format: "HH:mm"
  selectedTimeZone: string    // IANA time zone
): UTCWindow {
  // Parse and reformat start date and time
  const localStart = DateTime.fromFormat(
    `${campaignStartDate} ${startTime}`,
    "dd/MM/yyyy HH:mm",
    { zone: selectedTimeZone }
  );

  // Parse and reformat end date and time
  const localEnd = DateTime.fromFormat(
    `${campaignEndDate} ${endTime}`,
    "dd/MM/yyyy HH:mm",
    { zone: selectedTimeZone }
  );

  // Convert to UTC and split date and time
  const utcStart = localStart.toUTC();
  const utcEnd = localEnd.toUTC();

  return {
    utcStartDate: utcStart.toISODate() ?? "",       // e.g., "2025-07-17"
    utcStartTime: utcStart.toFormat("HH:mm:ss"),    // e.g., "05:30:00"
    utcEndDate: utcEnd.toISODate() ?? "",           // e.g., "2025-07-20"
    utcEndTime: utcEnd.toFormat("HH:mm:ss")         // e.g., "11:30:00"
  };
}
